import shuffle from '@huasi/text-shuffle';
import { gsap } from 'gsap';

import Chaos from './animation/chaos';
import ScrollFunc from './animation/scrollfunc';

export default class Animation {
  chaos: Object;
  scrollFunc: Object;

  constructor() {
    this.chaos = new Chaos();
    this.scrollFunc = new ScrollFunc();
    this.init();
  }

  init() {
    this.frontReady();
    this.pageReady();
    this.gnav();
  }

  frontReady() {
    const delay = 0;
    const frontPage = document.querySelector<HTMLElement>('.home');
    const shuffletxts =
      document.querySelectorAll<HTMLElement>('.js-kvshuffletxt');

    if (!frontPage) return;

    setTimeout(() => {
      document.body.setAttribute('data-ready', '1');
      document.documentElement.classList.add('-lock');
      document.body.classList.add('-lock');
    }, delay);

    setTimeout(() => {
      document.documentElement.classList.remove('-lock');
      document.body.classList.remove('-lock');

      shuffletxts.forEach((st) => {
        const shuffledtxt = shuffle({
          text: st!.getAttribute('data-txt') || '',
          duration: 1,
          onUpdate: (shuffleStr) => {
            st!.textContent = shuffleStr;
          },
        });
      });
    }, delay + 3200);

    gsap.to('.p-top-kv__mainph_wrap', {
      scale: 1.3,
      y: '10%',
      opacity: 0,
      scrollTrigger: {
        trigger: '.p-top-kv',
        start: 'top top',
        end: 'bottom top',
        scrub: 1,
      },
    });
  }

  pageReady() {
    const pageHeaderHead = document.querySelector<HTMLElement>(
      '.l-pageheader__head'
    );

    if (!pageHeaderHead) return;

    const delay = 0;

    setTimeout(() => {
      document.body.setAttribute('data-ready', '1');
    }, delay);

    setTimeout(() => {
      const shuffledtxt = shuffle({
        text: pageHeaderHead!.getAttribute('data-txt') || '',
        duration: 0.5,
        onUpdate: (shuffleStr) => {
          pageHeaderHead!.textContent = shuffleStr;
        },
      });
    }, delay + 500);
  }

  gnav() {
    const shuffleWrap = document.querySelectorAll<HTMLElement>(
      '.js-shuffletxt_wrap'
    );

    shuffleWrap.forEach((el) => {
      const txtTarget = el.querySelector<HTMLElement>('.js-shuffletxt');
      el.addEventListener('mouseenter', () => {
        if (window.innerWidth <= 768) return;
        const shuffledtxt = shuffle({
          text: txtTarget!.getAttribute('data-txt') || '',
          duration: 0.5,
          onUpdate: (shuffleStr) => {
            txtTarget!.textContent = shuffleStr;
          },
        });
      });
    });
  }
}
